/* eslint-disable max-len */
import Button from '@common_button';
import TextField from '@common_forms/TextField';
import Typography from '@common_typography';
import { useTranslation } from 'next-i18next';
import cx from 'classnames';

const FieldPoint = ({
    onChange = () => {},
    value = '',
    placeholder = '',
    action,
    disabled = false,
    id = null,
    name = null,
    error,
    errorMessage = 'error',
    loading = false,
    toggleField = false,
    styleFrame = {},
    styleFrameText = {},
    styleTextField = {},
}) => {
    const { t } = useTranslation(['common']);

    return (
        <div className="w-full" id={id}>
            <div className="flex flex-row items-start gap-3" style={styleFrame}>
                <TextField
                    id={`${id}Textfield`}
                    name={name}
                    styleFrameText={styleFrameText}
                    styleTextField={styleTextField}
                    disabled={!!(disabled || toggleField)}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    className="w-full tablet:w-[320px]"
                    absolute={false}
                    floatLabel={false}
                    hintProps={{
                        displayHintText: error,
                        hintText: errorMessage,
                        hintType: 'error',
                        className: 'max-w-[320px]',
                    }}
                    inputProps={{
                        className: cx(
                            toggleField ? '!bg-neutral-50 disabled:!bg-neutral-50' : '',
                        ),
                    }}
                />
                <Button
                    variant="outlined"
                    onClick={action}
                    disabled={disabled || loading || value === ''}
                    className={cx(
                        'h-[40px] swift-action-apply bg-neutral-black',
                        'disabled:bg-neutral-100 disabled:!text-neutral-white',
                    )}
                    loading={loading}
                >
                    <Typography
                        color={cx(
                            loading || disabled || value === '' ? 'text-neutral-400' : 'text-neutral-black group-hover:text-neutral-white',
                        )}
                        className="uppercase leading-normal text-sm"
                    >
                        {toggleField ? t('common:button:remove') : t('common:button:apply')}
                    </Typography>
                </Button>
            </div>
        </div>
    );
};

export default FieldPoint;
